"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDefault = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const alert_1 = __importStar(require("@kawaui/alert"));
const Alert = ({ open, onClose, onAccept, header = 'errors.something_failed.modal.title', content, button = 'common.close', i18n, children, }) => {
    const handleAcceptation = () => {
        onAccept && onAccept();
        onClose && onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(alert_1.default, { open, onClose, disableBackdropEvents: false, children: [header && (0, jsx_runtime_1.jsx)(alert_1.Header, { children: i18n(header) }), (0, jsx_runtime_1.jsx)(alert_1.Content, { children: content ? (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: i18n(content) } }) : children }), (0, jsx_runtime_1.jsx)(alert_1.Footer, { children: button && (0, jsx_runtime_1.jsx)(alert_1.AlertButton, { onClick: handleAcceptation, children: i18n(button) }) })] }));
};
const AlertDefault = ({ open, onClose, onAccept, statusText, error, i18n }) => {
    var _a;
    return ((0, jsx_runtime_1.jsx)(Alert, { open, onClose, onAccept, i18n, children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: (_a = error === null || error === void 0 ? void 0 : error.error_description) !== null && _a !== void 0 ? _a : statusText } }) }));
};
exports.AlertDefault = AlertDefault;
exports.default = Alert;
